import clsx from 'clsx';

type Props = {
  checked?: boolean;
  label: string;
  availableForSale: boolean;
};

export default function OptionButton({checked, label, availableForSale}: Props) {

  const handleScrollTop = () => {
    if (window && window.innerWidth < 1024) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div
      className={clsx([
        'relative w-fit border px-10 py-2 cursor-pointer overflow-hidden',
        checked ? 'text-main after:bg-main' : 'text-gray after:bg-gray',
        availableForSale && 'text-black',
        checked && availableForSale && '!text-main',
        !availableForSale && 'after:absolute after:-left-[3px] after:content-[""] after:w-[calc(100%+6px)] after:h-[1px] after:top-10 after:-rotate-[10deg]'
      ])}
      onClick={handleScrollTop}
    >
      {label}
    </div>
  );
}
